import {addDays, formatISO, startOfDay} from 'date-fns';

import type {CreateLinkFormValues} from '../types/forms';

export const MAX_NOTE_LENGTH = 300;
export const DEFAULT_LINK_TOP = 5;

export const createLinkInitialValues: CreateLinkFormValues = {
  emails: [''],
  expiry: formatISO(startOfDay(addDays(new Date(Date.now()), 15)), {
    representation: 'date',
  }),
  permissions: {
    downloads: true,
    reports: true,
    presentations: true,
  },
  note: '',
  presentationId: null,
};
